import { EventOwnerRole } from "src/types/api";

export function weddingRoleOptions(roles: string[]) {
  const labels: Partial<Record<EventOwnerRole, string>> = {
    bride: "Bride",
    groom: "Groom",
    planner: "Event Planner",
    bouncer: "Bouncer",
    asoebi: "Aso Ebi",
  };
  return roles
    .filter((role): role is EventOwnerRole => !!labels[role as EventOwnerRole])
    .map((role) => ({ value: role, label: labels[role]! }));
}
export const normalizeTeamPhone = (value: string) =>
  `+${value.replace(/\D/g, "")}`;
export const validTeamPhone = (value: string) =>
  /^\+[1-9]\d{6,14}$/.test(normalizeTeamPhone(value));
